export function Upload() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" fill="none" viewBox="0 0 84 84">
			<path
				fill="#367BF5"
				d="M67.725 35.14C65.345 23.065 54.74 14 42 14c-10.115 0-18.9 5.74-23.275 14.14C8.19 29.26 0 38.185 0 49c0 11.585 9.415 21 21 21h45.5C76.16 70 84 62.16 84 52.5c0-9.24-7.175-16.73-16.275-17.36zM49 45.5v14H35v-14H24.5L42 28l17.5 17.5H49z"
			/>
		</svg>
	);
}
